export function binaryToBlob(binary: Uint8Array, type: BlobPropertyBag['type']) {
  return new Blob([binary], { type });
}
export function base64ToBinary(base64: string) {
  const byteCharacters = window.atob(base64);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i += 1) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  return new Uint8Array(byteNumbers);
}

export function generateEphimeralDownloadLink(blob: Blob, filename: string) {
  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function downloadBase64File(
  base64: string,
  type: BlobPropertyBag['type'],
  filename = `file_download_${Date.now()}`,
) {
  const binary = base64ToBinary(base64);
  const blob = binaryToBlob(binary, type);
  generateEphimeralDownloadLink(blob, filename);
}
